import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import { SECTION_KEYS } from '../../constants/sections';
import CheckoutCard from '../CheckoutCard';
import EditView from './EditView';
import SummaryView from './SummaryView';

function AccountInfoCard({ hideEdit, sectionNumber }) {
  const sectionKey = SECTION_KEYS.ACCOUNT_INFO;

  const MESSAGE_IDS = {
    title: 'shopping.page.checkoutSmartLlc.accountInfoCard.title'
  };

  return (
    <CheckoutCard
      hideEdit={hideEdit}
      sectionKey={sectionKey}
      sectionNumber={sectionNumber}
      title={<FormattedMessage id={MESSAGE_IDS.title} />}
    >
      <CheckoutCard.Summary>
        <SummaryView sectionKey={sectionKey} />
      </CheckoutCard.Summary>
      <CheckoutCard.Edit>
        <EditView sectionKey={sectionKey} />
      </CheckoutCard.Edit>
    </CheckoutCard>
  );
}

AccountInfoCard.propTypes = {
  hideEdit: PropTypes.bool,
  sectionNumber: PropTypes.number.isRequired
};

export default AccountInfoCard;
